export enum DialogSize {
  SM = '480px',
  MD = '620px',
  LG = '720px',
  XL = '860px',
}

export const DEFAULT_DIALOG_OPTIONS = {
  maxWidth: '95vw',
  maxHeight: '95vh',
  width: DialogSize.MD,
};

export type ConfirmationDialogMode = 'confirm' | 'danger';

export interface ConfirmationDialogData {
  title: string;
  message: string;
  confirmAction: string;
  cancelAction?: string;
  mode: ConfirmationDialogMode;
}

export interface ConfirmationDialogOptions {
  title: string;
  message: string;
  confirmActionLabel: string;
  cancelActionLabel?: string;
  mode?: ConfirmationDialogMode;
  disableClose?: boolean;
  restoreFocus?: boolean;
}
